// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Start_wrapper__3vNcf","title":"Start_title__2czod","checkBox":"Start_checkBox__2p1qn","start":"Start_start__1Gj3O","blinker":"Start_blinker__2ieBv"};